import $ from 'cash-dom';

export default function initEditorNoteDismiss() {
  $(document).on('click', '.article-mobile-editor-note__close', function (event) {
    event.preventDefault();

    const note = this.closest('.article-mobile-editor-note');
    if (note) {
      note.style.display = 'none';
    }
  });
}
